import * as React from 'react';

import { ThemeContext, type Theme } from './use-theme';

// DocuShare/MissionControll reskin: a kulcs 'theme', az alapértelmezés DARK.
const STORAGE_KEY = 'theme';

function resolve(theme: Theme): 'light' | 'dark' {
  if (theme === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return theme;
}

// A <html>-re a theme-{dark|light} (glass-réteg) ÉS a dark (shadcn) osztály is kell.
function apply(theme: Theme): void {
  const resolved = resolve(theme);
  const html = document.documentElement;
  html.classList.remove('theme-dark', 'theme-light', 'dark');
  html.classList.add(`theme-${resolved}`);
  if (resolved === 'dark') html.classList.add('dark');
}

export function ThemeProvider({
  children,
  defaultTheme = 'dark',
}: {
  children: React.ReactNode;
  defaultTheme?: Theme;
}): JSX.Element {
  const [theme, setThemeState] = React.useState<Theme>(
    () => (localStorage.getItem(STORAGE_KEY) as Theme | null) ?? defaultTheme,
  );

  React.useEffect(() => {
    apply(theme);
  }, [theme]);

  const setTheme = React.useCallback((next: Theme) => {
    localStorage.setItem(STORAGE_KEY, next);
    setThemeState(next);
  }, []);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}
